import React from 'react';
import sideScreenStyle from 'acscp/components/common/sideScreen.module.scss';
import style from './accountNotifications.module.scss';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { AppState, Menu } from 'acscp/store';
import { Dispatch } from 'redux';
import { SideScreen } from 'acscp/components/common/sideScreen';
import { SetOpenMenu } from 'acscp/actions';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import classNames from 'classnames';
import { FormattedDate } from './formattedDate';
import { getAccountNotifications } from 'acscp/store/selectors/accountNotificationSelector';
import { AccountNotification } from 'acscp/api/models/accountNotification';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { AccountNotificationTitle } from './accountNotificationsTitle';

interface AccountNotificationsStateProps {
    isOpen: boolean;
    notifications: AccountNotification[];
}

interface AccountNotificationsDispatchProps {
    closeMenu: () => void;
}

export class AccountNotificationsPresentational extends PresentationComponentBase<{},
    AccountNotificationsStateProps, AccountNotificationsDispatchProps, {}> {

    render(): JSX.Element | null {
        return this.props.isOpen
            ? (
                <SideScreen>
                    <div className={sideScreenStyle.BlueHeader} >
                        <FormattedMessage
                            id={'components.accountNotifications.notifications'}
                            defaultMessage={'NOTIFICATIONS'}
                        />
                        <a id="Exit" onClick={this.props.closeMenu} aria-label="Close menu">
                            <CrossIcon />
                        </a>
                    </div>
                    {this.props.notifications.map((notification, index) =>
                        <div
                            className={classNames(
                                style.NotificationItem,
                                sideScreenStyle.WithBorder,
                                {
                                    [style.Unread]: !notification.hasBeenRead
                                })
                            }
                            key={`${notification.id} ${index}`}
                        >
                            <div className={style.UnreadIcon} />
                            <Link to={`/trip/${notification.bookingId}`} className={style.ItemContent} onClick={this.props.closeMenu}>
                                <AccountNotificationTitle notification={notification} />
                                <div className={style.Message}>
                                    {notification.message}
                                </div>
                                <div className={style.Date}>
                                    <FormattedDate date={notification.createdAt}/>
                                </div>
                            </Link>
                        </div>
                    )}
                </SideScreen>
            )
            : (
                null
            );
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): AccountNotificationsDispatchProps {
    return {
        closeMenu: () => dispatch(new SetOpenMenu(undefined)),
    };
}

function mapStateToProps(state: AppState, ownProps: {}): AccountNotificationsStateProps {
    return {
        isOpen: state.menu.currentlyOpenMenu === Menu.AccountNotifications,
        notifications: getAccountNotifications(state)
    };
}

export const AccountNotifications =
    connectWithRequests(mapStateToProps, mapDispatchToProps)(AccountNotificationsPresentational);
